import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { PageOptions, StructureTotemListProvider, TotemTOEditProvider } from 'cw-backend';
import { SnackBarService } from 'cw-utils';
import { TotemControl } from '../../../../../../../shared/cw-backend/models/application/totem/totem-control';


@Component({
  selector: 'cw-list-passwords',
  templateUrl: './list-passwords.component.html',
  styleUrls: ['./list-passwords.component.scss']
})
export class ListPasswordsComponent implements OnInit, AfterViewInit {

  @Output() back: EventEmitter<any> = new EventEmitter();
  @Output() oCallPassword: EventEmitter<any> = new EventEmitter();
  @Input() companyId!: number;
  @Input() environmentId!: number;
  @Input() typeList!: string;

  displayedColumns: string[] = ['password', 'patient_status', 'environment', "action"];
  dataSource: any;

  loadingCallPassword: boolean = false;

  nextPageOptions = new PageOptions();
  public totalElements = 0;
  public number = 0;
  public sizePage = 10;


  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private structureTotemListProvider: StructureTotemListProvider,
    private totemEdit: TotemTOEditProvider,
    private snackbar: SnackBarService
  ) {
    this.nextPageOptions.fieldSort = "createdAt";
    this.nextPageOptions.sortDirection = 'asc';
    this.nextPageOptions.sizePage = 5;
  }

  ngOnInit() {
    this.getPasswords();
  }

  getPasswords() {
    if (this.typeList === 'NEXT') {
      this.getNextPasswords();
    } else {
      this.getOldPasswords();
    }
  }

  getNextPasswords() {
    this.structureTotemListProvider
      .listNextPassword
      (this.companyId, this.environmentId, this.nextPageOptions)
      .then((res: any) => {
        this.dataSource = res.body.data.content;
        const page = res.body.data;
        this.number = page.number;
        this.sizePage = page.size;
        this.totalElements = page.totalElements;

      })
  }

  getOldPasswords() {
    this.structureTotemListProvider
      .listOldPassword
      (this.companyId, this.nextPageOptions)
      .then((res: any) => {
        this.dataSource = res.body.data.content;
        const page = res.body.data;
        this.number = page.number;
        this.sizePage = page.size;
        this.totalElements = page.totalElements;

      })
  }

  updatePage(eventPaginator: any): void {
    this.nextPageOptions.sizePage = eventPaginator.pageSize;
    this.nextPageOptions.page = eventPaginator.pageIndex
    this.getPasswords();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  goBack() {
    this.back.emit();
  }

  callPassword(password: any) {
    this.loadingCallPassword = true;
    switch (this.typeList) {
      case 'OLD':
        this.callOldPassword(password)
        break;

      case 'NEXT':
        this.callNextPassword(password)
        break;

      default:
        break;
    }

  }

  cancelPassword(password: any) {
    this.totemEdit
      .cancelPassword(password.id)
      .then(res => {
        this.getPasswords();
        this.snackbar.successMessage("Cancelada com sucesso.")
      })
  }

  callNextPassword(password: any) {
    this.totemEdit
      .callPassword(password.id, this.environmentId)
      .then(res => {
        this.loadingCallPassword = false;
        this.oCallPassword.emit(password);
      }).catch(err => {
        this.loadingCallPassword = false;
      })
  }
  callOldPassword(password: TotemControl) {
    password.companyId = this.companyId;
    password.environmentId = this.environmentId;
    this.totemEdit
      .callOldPassword(password)
      .then(res => {
        this.loadingCallPassword = false;
        this.oCallPassword.emit(password);
      }).catch(err => {
        this.loadingCallPassword = false;
      })
  }
}
